import { config } from '../config.js';

/**
 * 문서형 화면의 머리. **시청 화면에는 씌우지 않는다** — 그쪽은 전체화면 비디오 위의
 * 오버레이 레이어이고, 헤더가 오버레이 좌표를 밀어낸다 (`docs/06` 「화면 구조」).
 *
 * B8 이 `App.tsx` 에서 떼어 냈다. 로그인 화면이 같은 머리를 써야 하는데, 그 화면은
 * 부팅 단계상 `App` 보다 앞에서 그려질 수 있다.
 */
export function AppHeader() {
  return (
    <header className="app__header">
      <a className="app__title" href="/">
        BLOOM
      </a>
      {config.debug && <span className="badge badge--warn">debug</span>}
    </header>
  );
}
